module.exports = __webpack_public_path__ + "static/media/icon-wechat-hover.8d857ba1.png";